import { FC } from 'react';
import { styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Dialog } from '../Dialog';
import { CrossInCircleIcon } from '../Icons';
import { ConfirmDialogProps } from './types';
import { colors } from 'variables';
import { Button } from '../Button';

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: '1.4rem',
    padding: '3rem 2rem',
  },
}));

export const ConfirmDialog: FC<ConfirmDialogProps> = ({ onClose, open, titleKey, onCancel, onConfirm }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <CrossInCircleIcon className={'absolute top-5 right-5'} color={colors.primary} onClick={handleClose} />

      <h3 className={'mb-6 text-center'}>
        <FormattedMessage id={titleKey} />
      </h3>
      <div className={'flex'}>
        <Button color={'error'} className={'md:mr-2'} onClick={onCancel}>
          <FormattedMessage id={'cta.cancel'} />
        </Button>
        <Button onClick={onConfirm} className={'md:ml-2'}>
          <FormattedMessage id={'cta.confirm'} />
        </Button>
      </div>
    </StyledDialog>
  );
};
